import yup from 'utils/yup';

export const initialXeroFilterData = {
  user_id: [] as any,
  start_date: null as any,
  end_date: null as any,
};

export const xeroFilterValidationSchema = yup.object().shape({
  user_id: yup
    .array()
    .of(yup.string().required({ msg: 'User ID is required' }))
    .min(1, { msg: 'At least one user must be selected' }),
  start_date: yup.date().required({ msg: 'This is required' }).typeError({ msg: 'This must be a valid date' }),
  end_date: yup
    .date()
    .required({ msg: 'This is required' })
    .typeError({ msg: 'This must be a valid date' })
    .min(yup.ref('start_date'), { msg: 'End date cannot be before start date' }),
});
